import React,{useEffect, useState} from "react";
import { Link } from "react-router-dom";
//import Anagram from 'react-anagram-animation';
import './styles/home.css';
const wlcmMSG = {
    'English':'Hi!',
    'Hindi':'Namaste!',
    'Russian':'Privet!',
    'German':'Moin!',
}
const KEY = ['English','Hindi','Russian','Moin'];
export default function Home(){
    const [wlcm,setWlcm] = useState("");

    const getRandomIndex = ()=>{
        return Math.floor(Math.random()*3);//hard coded
    }
    useEffect(()=>{
        let item = KEY[parseInt(getRandomIndex())];
        setWlcm(item);
    },[]);
    return(
        <div className="home">
            <p>
                <span style={{"fontSize":"64px"}}>{wlcmMSG[wlcm]+","}</span><br/>
                <span style={{"fontSize":"30px"}}> I'm Ishaan 😊</span><br/>
                a Philomath, <span style={{"color":"pink"}}>who love solving real time problems</span>, <span style={{"color":"lightblue"}}><br/>creating full stack web pages </span>, <span style={{"color":"lightgreen"}}> learning pentesting</span>,<br/>
                <span style={{"color":"yellow"}}>and ML enthusiast.</span><br/>
            <h4>Wanna Know more! <Link to={"/about"} className="btn btn-primary">About</Link></h4>
            </p>
        </div>
    ); 
}